import { Injectable, inject } from '@angular/core';
import { StorageService } from './storage.service';
import { NotificationService } from './notification.service';
import { CurrentUserService } from './current-user.service';

const MODULE_NOTIFICATIONS = 'moduleNotifications';

import { IModuleNotificationModel } from './notification.service';
import { UserType } from '@medicalapp/shared-core';

@Injectable({
  providedIn: 'root',
})
export class ModuleNotificationService {
  private readonly storageService = inject(StorageService);
  private readonly notificationService = inject(NotificationService);
  private readonly currentUserService = inject(CurrentUserService);

  private cachedNotifications: IModuleNotificationModel[] = [];

  constructor() {
    this.loadInitialNotifications();
  }

  private async loadInitialNotifications() {
    try {
      const raw = await this.storageService.get(MODULE_NOTIFICATIONS);
      this.cachedNotifications = raw ? JSON.parse(raw) : [];
    } catch {
      this.cachedNotifications = [];
    }
  }

  get = async (moduleName = '') => {
    const currentUser = this.currentUserService.currentUser();
    const userId = currentUser?.refId;
    if (!userId) return;

    const userType = UserType.Patient; // Patient

    this.notificationService
      .getModuleNotificationCount(userType, userId, moduleName)
      .subscribe({
        next: async (response) => {
          let notifications = response?.data;
          if (moduleName) {
            const raw = await this.storageService.get(MODULE_NOTIFICATIONS);
            const moduleNotifications: IModuleNotificationModel[] = raw ? JSON.parse(raw) : [];
            notifications = moduleNotifications?.map((module) => {
              const moduleNotification = response?.data?.find(
                (notificationModule) =>
                  notificationModule?.moduleName?.toLowerCase() === module?.moduleName?.toLowerCase()
              );
              return {
                ...module,
                notificationCount: moduleNotification
                  ? moduleNotification?.notificationCount
                  : module?.notificationCount,
              };
            }) || [];
          }

          await this.set(JSON.stringify(notifications));
        }
      });
  };

  private set = async (moduleNotifications: string) => {
    try {
      this.cachedNotifications = JSON.parse(moduleNotifications);
    } catch {
      // fallback
    }
    await this.storageService.set(MODULE_NOTIFICATIONS, moduleNotifications);
  };

  getCount = (moduleName: string) => {
    const module = this.cachedNotifications?.find(
      (moduleItem) =>
        moduleItem?.moduleName?.toLowerCase() === moduleName?.toLowerCase()
    );
    return module ? module?.notificationCount : 0;
  };
}
